export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8635.424fd280.jpg";